<template>
  <div class="main">
    <div class="mainCon">
      <el-container class="main-container">
        <el-aside width="216px">
          <div class="teachers">
            <div class="toux">
              <!-- <i class="el-icon-user-solid"></i> -->
              <img src="../../../../static/images/main/teacher_tx.svg" />
            </div>
            <div class="teacherCon">
              <p>{{$store.state.loginDatas.employ_name}}</p>
              <!-- <p>{{$store.state.loginDatas.school_name}}</p> -->
              <div class="schoolSel">
                <el-select v-model="schoolId" placeholder="请选择校区" class="region" style="margin-left:0;width:160px;" size="small" @change="selectShool" v-if="schoolOption.length>1">
                  <el-option v-for="item in schoolOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <div v-else class="schoolName" v-for="item in schoolOption">{{item.label}}</div>
              </div>
              <p>{{$store.state.loginDatas.phone_number}}</p>
            </div>
          </div>
          <sidebarNav class="sidebar" />
        </el-aside>
        <div style="width:984px;" id="container">
          <Content />
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
import sidebarNav from './main-content/sidebar-nav';
import Content from './main-content/content';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      height: 0,
      h: 0,
      loginDatas: [],
      schoolOption: [],
      schoolId: null
    };
  },
  // watch: {
  //   $route: {
  //     handler (val, oldval) {
  //       if (val) {
  //         let bodyH = document.getElementById("container").children.content.clientHeight;
  //         console.log(bodyH);
  //         this.h = bodyH;
  //       }
  //       console.log(val);//新路由信息
  //       console.log(oldval);//老路由信息
  //     },
  //     // 深度观察监听
  //     deep: true
  //   }
  // },
  computed: {
    ...mapState(['isSidebarNavCollapse'])
  },
  components: {
    Content,
    sidebarNav,
  },
  mounted () {
    let mainH = document.documentElement.clientHeight;
    this.height = mainH - 80;
    this.$store.state.schoolList.map(item => {
      this.schoolOption.push({
        label: item.school_name,
        value: item.school_id
      });
    });
    this.schoolId = sessionStorage.getItem("school_id");
    // if (!this.$store.state.school_id) {
    //   this.$store.commit('SET_ShoolId', this.schoolOption[0].value);
    //   this.schoolId = this.schoolOption[0].value;
    // } else {
    //   this.schoolId = localStorage.getItem("school_id");
    // }
    // let bodyH = document.getElementById("container").children.content.clientHeight;
    // console.log(bodyH);
    // this.h = bodyH;
  },
  methods: {
    selectShool (val) {
      let primossId = null;
      let sellType = null;
      this.$store.state.schoolList.map(item => {
        if (item.school_id == val) {
          primossId = item.post_permission_code;
          sellType = item.sell_type;
        }
      });
      this.$store.commit('SET_ShoolId', { school_id: val, sell_type: sellType });
      this.$store.commit('SET_post_permission_code', primossId);
      window.location.reload();
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  background: url("../../../../static/images/main/bj.png") #f9faff;
  background-repeat: no-repeat;
  background-size: 100% 50%;
  width: 100%;
  height: calc(100% - 108px);
  padding: 28px 0;
  overflow-y: auto;
  box-sizing: border-box;
}
.mainCon {
  background: #f9faff;
  width: 1200px;
  /* height: 976px; */
  margin: 0 auto;
}
.el-aside {
  box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.12);
  height: 976px;
}
.schoolSel {
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .el-select {
    margin: 6px 0;
  }
  /deep/ .el-select .el-input--small .el-input__inner {
    color: #606060;
    font-size: 14px;
  }
}
.toux {
  img {
    width: 70px;
    height: 70px;
  }
}
.schoolName {
  margin: 12px 0;
  color: #606060;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/mainContent.vue